import { t } from '@/i18n';


/**
 * 联系方式
 * 1：手机号，2：微信，3：QQ，4：邮箱
 */
export enum EnumContactType {
    Mobile = 1,
    Wechat = 2,
    Qq = 3,
    Email = 4,
    Line = 5,
}

/**
 * 联系方式(enum)
 * 1：手机号，2：微信，3：QQ，4：邮箱，5：Line
 */
const normalizeRegion = (region?: string | null) => {
  const key = String(region || '').trim().toLowerCase();
  console.log(key, 'keykeykey');
  if (!key) return '';
  if (['cn', 'china', '中国', 'zh-cn', 'zh_cn', 'zh'].includes(key)) return 'china';
  if (['jp', 'japan', '日本', 'ja', 'ja-jp', 'ja_jp'].includes(key)) return 'japan';
  return '';
};

export const getDictContactType = (region?: string | null) => {
  const normalized = normalizeRegion(region);
  if (normalized === 'china') {
    return [
      { label: t('contactWechat'), value: EnumContactType.Wechat },
      { label: t('contactQq'), value: EnumContactType.Qq },
      { label: t('contactEmail'), value: EnumContactType.Email },
      { label: t('contactMobile'), value: EnumContactType.Mobile },
    ];
  }
  if (normalized === 'japan') {
    return [
      { label: t('contactEmail'), value: EnumContactType.Email },
      { label: t('contactLine'), value: EnumContactType.Line },
    ];
  }
  return [{ label: t('contactEmail'), value: EnumContactType.Email }];
};


